import "./button.css";

export default function Button({
  buttonText,
  buttonLink,
  theme,
}: {
  buttonText: string;
  buttonLink: string;
  theme: string;
}) {
  return (
    <a
      className={`ae-button -shadow -hover-animation -${theme}`}
      href={buttonLink}
      data-testid="button"
    >
      {buttonText}
    </a>
  );
}
